import { FC, useState } from 'react'

import useCurrentSubProductDashboards from 'src/hooks/useCurrentSubProductDashboards'
import { cn } from 'src/lib/cn'
import { isTrueOrUndefinedFn } from 'src/utils/booleanUtils'
import IconButton from '../../atoms/IconButton'
import DropdownBoldArrowIcon from '../../atoms/Icons/DropdownBoldArrowIcon'
import PopupButton from '../../atoms/PopupButton'
import { PopupButtonContext } from '../../atoms/PopupButton/PopupButtonProvider'
import PageHeaderListDashboardsPopup from './PageHeaderListDashboardsPopup'

const PageHeaderListDashboards: FC = () => {
  const subProductDashboards = useCurrentSubProductDashboards()
  const [isFocused, setIsFocused] = useState(false)
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  if (!subProductDashboards.filter(d => isTrueOrUndefinedFn(d.display_on_left_nav)).length)
    return null

  return (
    <PopupButton
      popupComponent={
        <PageHeaderListDashboardsPopup
          dashboards={subProductDashboards}
          setIsFocused={setIsFocused}
        />
      }
      openOnHover
      isOpen={isPopoverOpen || isFocused}
      togglePopup={setIsPopoverOpen}
      isLazy
      data-testid="page-header-list-dashboards"
      buttonComponent={
        <PopupButtonContext.Consumer>
          {popupProps => (
            <IconButton
              noBorder
              className={cn(
                'text-rolling-stone bg-porcelain size-[1.5625rem] rounded-sm',
                popupProps?.isOpen && 'text-black',
              )}
            >
              <DropdownBoldArrowIcon direction="down" />
            </IconButton>
          )}
        </PopupButtonContext.Consumer>
      }
      classes={{
        Popup:
          'bg-white w-fit shadow-popup! rounded-xl min-w-44 mt-1! min-h-37 min-w-[279px] max-h-110 overflow-y-auto pt-0!',
      }}
      popupFixedProps={{ anchorOrigin: 'left' }}
      needToPassChildToggleProps={false}
      mouseLeaveActiveDirection="down"
    />
  )
}

export default PageHeaderListDashboards
